import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

export function sweetAlert(options = {}) {
  const { title, text, icon = 'info', ...rest } = options;
  return MySwal.fire({
    title,
    text,
    icon,
    ...rest,
  });
}
